function passwordEqualityValidator({ fieldValues, fields, input, msgs, params }) {
  const field = fields[params.clientId];
  const value = fieldValues[params.clientId];

  if (field && value !== input) {
    return (msgs && msgs.msg) || `Value must match ${field.label}`;
  }

  return null;
}

export default passwordEqualityValidator;
